import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Tabs, Col, Input, InputNumber } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

function TestimonialAddEdit() {
	const navigate = useNavigate();
	const { editTestimonialId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	const get = () => {
		if (!editTestimonialId) return;

		setIsLoading(true);
		axios
			.get(`/testimonials`, { params: { _id: editTestimonialId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const [data] = result.data.data;
					form.setFieldsValue(data);
				}
			})
			.catch(() => {})
			.finally(() => setIsLoading(false));
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editTestimonialId) values._id = editTestimonialId;

				axios({
					method: editTestimonialId ? 'put' : 'post',
					url: '/testimonials',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/testimonials');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => console.log(e));
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { label: 'Testimonials' }]} />
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editTestimonialId ? 'Edit Testimonial' : 'Add Testimonial'}</div>
						<div className='page-title-more'>
							<Link to='/testimonials'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave} loading={isLoading}>
								Save
							</Button>
						</div>
					</div>

					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Tabs
								defaultActiveKey='1'
								items={[
									{
										key: 'Details',
										label: 'Details',
										children: (
											<>
												<Col sm={24} md={12}>
													<Form.Item label='Name' name='name' rules={[{ required: false, message: 'Name is required' }]}>
														<Input placeholder='Enter client name' autoFocus />
													</Form.Item>
												</Col>

												<Col sm={24} md={12}>
													<Form.Item label='Role' name='role' rules={[{ required: false, message: 'Role is required' }]}>
														<Input placeholder='Enter client role' />
													</Form.Item>
												</Col>

												<Col sm={24} md={12}>
													<Form.Item label='Feedback' name='feedback' rules={[{ required: false, message: 'Feedback is required' }]}>
														<Input.TextArea rows={4} placeholder='Enter client feedback' />
													</Form.Item>
												</Col>

												<Col sm={24} md={12}>
													<Form.Item label='Rating' name='rating' rules={[{ required: false, message: 'Rating is required' }]}>
														<InputNumber min={1} max={5} placeholder='Enter rating (1-5)' style={{ width: '100%' }} />
													</Form.Item>
												</Col>
											</>
										),
									},
								]}
							/>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default TestimonialAddEdit;
